import React from "react";
import { useNavigate } from "react-router-dom";

/*
  Polite placeholder for the next chain in the spine.

  The "Next · The Shaped Stone" button on /chains/the-first-walker
  navigates here. Until the editorial team locks Chain 1 · Episode 2,
  judges and readers land on a quiet "coming next" card with a clear
  way back to The First Walker and to /world.

  When Chain 1 · Episode 2 ships, replace this component with the
  actual chain player (or route /chains/the-shaped-stone to its
  dedicated component, same pattern as TheFirstWalker.jsx).
*/

const COLORS = {
  ash: "#0d0c0a",
  ashSoft: "#15130f",
  bone: "#e8e2d4",
  boneDim: "#a8a08c",
  ember: "#c2703d",
  line: "#2a261f",
};

export default function TheShapedStone() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        background: COLORS.ash,
        minHeight: "100vh",
        color: COLORS.bone,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
      data-testid="shaped-stone-root"
    >
      <div
        style={{
          maxWidth: 640,
          textAlign: "center",
          border: `1px solid ${COLORS.line}`,
          borderRadius: 8,
          background: COLORS.ashSoft,
          padding: "48px 36px",
        }}
      >
        <p
          style={{
            color: COLORS.ember,
            letterSpacing: "0.22em",
            fontSize: 12,
            textTransform: "uppercase",
            marginBottom: 14,
          }}
          data-testid="shaped-stone-eyebrow"
        >
          Chain 1 · Episode 2
        </p>
        <h1
          style={{
            fontFamily: "'Spectral', Georgia, serif",
            fontSize: 44,
            lineHeight: 1.05,
            margin: 0,
            color: COLORS.bone,
            fontWeight: 700,
          }}
          data-testid="shaped-stone-title"
        >
          The Shaped Stone
        </h1>
        <p
          style={{
            marginTop: 22,
            color: COLORS.boneDim,
            fontFamily: "'Newsreader', Georgia, serif",
            fontSize: 17,
            lineHeight: 1.6,
            fontStyle: "italic",
          }}
          data-testid="shaped-stone-status"
        >
          In production with the triangulation team. Sources locked. Writer
          drafting. Three testers and three auditors review before founder
          lock. This page lights up the moment the chain clears.
        </p>
        <div
          style={{
            marginTop: 32,
            display: "flex",
            gap: 12,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={() => navigate("/chains/the-first-walker")}
            data-testid="shaped-stone-back-to-walker-btn"
            style={{
              background: "transparent",
              border: `1px solid ${COLORS.line}`,
              color: COLORS.bone,
              padding: "12px 22px",
              borderRadius: 999,
              fontSize: 13,
              letterSpacing: "0.06em",
              cursor: "pointer",
            }}
          >
            ◄ Back to The First Walker
          </button>
          <button
            onClick={() => navigate("/world")}
            data-testid="shaped-stone-time-machine-btn"
            style={{
              background: COLORS.ember,
              color: COLORS.ash,
              border: "none",
              padding: "12px 22px",
              borderRadius: 999,
              fontSize: 13,
              fontWeight: 700,
              letterSpacing: "0.06em",
              cursor: "pointer",
            }}
          >
            Back to the Time Machine
          </button>
        </div>
      </div>
    </div>
  );
}
